import './dummy-logo.scss';
import Logo from '../../../asset/images/reformcloud_vertical.png';

export const DummyLogo = () => (
  <div className="dummy__logo">
    <img src={Logo} alt="リフォームクラウド" />
  </div>
);
